/*
 * Broadcast Theme — custom.js
 */

(function () {
  'use strict';

  /* ─────────────────────────────────────────────────────────────────
   * "VIEW MORE" load-more button on the homepage
   * Fetches /collections/featured (page 1, then page 2 if needed),
   * skips products already visible on the page, and injects the
   * remaining cards in a responsive grid below the button section.
   * ───────────────────────────────────────────────────────────────── */

  function initViewMore() {
    var btn = document.querySelector(
      '[data-section-type="rich-text"] a[href*="/collections/featured"]'
    );
    if (!btn) return;

    var section  = btn.closest('[data-section-type="rich-text"]');
    var fetching = false;
    var done     = false;

    /* Build the grid container */
    var outer = document.createElement('div');
    outer.className = 'vm-grid-outer';
    outer.setAttribute('aria-live', 'polite');
    outer.style.cssText = [
      'padding:0 var(--outer,20px) 60px',
      'max-width:var(--wrapper-width,1600px)',
      'margin:0 auto',
      'opacity:0',
      'transition:opacity 0.5s ease',
    ].join(';');

    var grid = document.createElement('div');
    grid.className = 'grid';
    grid.style.cssText = [
      '--COLUMNS:4',
      '--COLUMNS-MEDIUM:2',
      '--COLUMNS-SMALL:2',
      '--COLUMNS-MOBILE:2',
    ].join(';');

    outer.appendChild(grid);
    section.after(outer);

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (fetching || done) return;

      fetching = true;
      var btnSpan  = btn.querySelector('span') || btn;
      var origText = btnSpan.textContent;
      btnSpan.textContent = 'Loading…';
      btn.setAttribute('disabled', 'disabled');
      btn.style.opacity = '0.6';

      /* Snapshot every product handle already visible on the page */
      var existing = new Set(
        Array.from(document.querySelectorAll('a[href*="/products/"]')).map(function (a) {
          return a.pathname.replace(/\?.*/, '');
        })
      );

      /* Try to fill 8 fresh cards; fall back to page 2 if page 1 is all duplicates */
      loadPage('/collections/featured', existing, 8)
        .then(function (freshItems) {
          if (!freshItems.length) {
            /* All page-1 items were already on screen — try page 2 */
            return loadPage('/collections/featured?page=2', existing, 8);
          }
          return freshItems;
        })
        .then(function (freshItems) {
          if (!freshItems.length) {
            window.location = btn.href;
            return;
          }

          freshItems.forEach(function (item) {
            item.querySelectorAll('[data-aos]').forEach(function (el) {
              el.classList.add('aos-animate');
            });
            grid.appendChild(item);
          });

          outer.style.opacity = '1';
          setTimeout(function () {
            outer.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }, 80);

          done = true;
          btn.style.display = 'none';
        })
        .catch(function (err) {
          console.warn('[view-more]', err);
          btnSpan.textContent = origText;
          btn.removeAttribute('disabled');
          btn.style.opacity = '';
        })
        .finally(function () { fetching = false; });
    });
  }

  /* Fetch a collection page and return up to `limit` items not in `existing` */
  function loadPage(url, existing, limit) {
    return fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc   = new DOMParser().parseFromString(html, 'text/html');
        var items = Array.from(doc.querySelectorAll('#CollectionLoop > *'));
        var fresh = [];

        for (var i = 0; i < items.length && fresh.length < limit; i++) {
          var link = items[i].querySelector('a[href*="/products/"]');
          var path = link ? link.pathname.replace(/\?.*/, '') : null;
          if (!path || !existing.has(path)) {
            fresh.push(items[i]);
          }
        }
        return fresh;
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initViewMore);
  } else {
    initViewMore();
  }

})();
